import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 设置主体色
	 * @data {string} theme： polarNightBlue（极夜蓝）、moonLightWhite（月光白）
	**/
    setTheme(id, data) {
		return request({
	    url: baseUrl + '/auth/setTheme/'+id,
	    method: 'POST',
	    data
	  })
	}
}